import { Button } from "@shared/ui/button";

const KEY = "airel.age-ok";

/** Каналы, где человек уже подтвердил возраст, — на этом устройстве. */
export function ageConfirmed(): Set<string> {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(parsed) ? parsed.filter((item): item is string => typeof item === "string") : []);
  } catch {
    return new Set();
  }
}

export function confirmAge(channelId: string): Set<string> {
  const next = ageConfirmed();
  next.add(channelId);
  try {
    localStorage.setItem(KEY, JSON.stringify([...next]));
  } catch {
    // Не записалось — спросим ещё раз в следующий раз.
  }
  return next;
}

/**
 * Канал с возрастным ограничением — как в Discord: прежде чем показать ленту,
 * спрашиваем, есть ли 18. Ответ «да» помнится для этого канала на устройстве.
 */
export function AgeGate({ name, onContinue, onLeave }: { name: string; onContinue: () => void; onLeave: () => void }) {
  return (
    <section className="sheet pane-surface">
      <div className="age-gate-wrap">
        <div className="age-gate">
          <div className="age-gate-mark">18+</div>
          <h2 className="age-gate-title">Канал с возрастным ограничением</h2>
          <p className="small muted">
            В #{name} может быть то, что не годится для младше 18 лет. Продолжая, вы подтверждаете, что
            вам есть 18.
          </p>
          <div className="line" style={{ gap: 8, justifyContent: "center" }}>
            <Button type="button" variant="secondary" onClick={onLeave}>
              Уйти
            </Button>
            <Button type="button" onClick={onContinue}>
              Продолжить
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
